import { render, staticRenderFns } from "./CallLogFilter.vue?vue&type=template&id=54180dc6&"
import script from "./CallLogFilter.vue?vue&type=script&lang=js&"
export * from "./CallLogFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports